module.exports = __webpack_public_path__ + "img/courses-image.95c2ca15.jpg";